import { render, staticRenderFns } from "./ResearchPlatform.vue?vue&type=template&id=2ff9fbf0&scoped=true"
import script from "./ResearchPlatform.vue?vue&type=script&lang=js"
export * from "./ResearchPlatform.vue?vue&type=script&lang=js"
import style0 from "./ResearchPlatform.vue?vue&type=style&index=0&id=2ff9fbf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff9fbf0",
  null
  
)

export default component.exports